module.exports = __webpack_public_path__ + "static/solucion-image-6efd237c8b27d6911575e474a06c890e.png";